module.exports = __webpack_public_path__ + "static/image1-785dde246eb44ccb31859d37ec0d7a96.png";